import { MEMBERSHIP_AGREEMENT_URL } from './Common';

/**
 * Central registry of static route paths. Keep this in sync with the route
 * definitions in `src/routes/` so the sidebars and links can't drift.
 */
export const PROFILE_ROUTES = {
  myProfile: '/profile/my-profile',
  notifications: '/profile/notifications',
  terms: '/terms',
} as const;

export const STAFF_ROUTES = {
  dashboard: '/staff/dashboard',
} as const;

export const EXTERNAL_LINKS = {
  helpCentre: 'https://knowledge.screenrights.org/en',
  membershipAgreement: MEMBERSHIP_AGREEMENT_URL,
} as const;
